/**
 * @packageDocumentation
 * @module f1/is
 */

import is_object from './is_object';

const GeneratorConstructor = function* () {}.constructor;

export interface IsGenerator {
  /**
   * Is a generator function
   *
   * @public
   * @function f1.is.generator
   * @example
   *
   * ```ts
   * f1.is.generator(function* () {
   *   yield 'go';
   * }) => true
   * ```
   */
  (value: unknown): value is Function;
}

/**
 * @see IsGenerator
 */
export default (u: unknown): u is GeneratorFunction => {
  return is_object(u) && u.constructor === GeneratorConstructor;
};
